/** @import modules */

import { useEffect }        from "react";

import { useLocation }      from "react-router-dom";

/**
 * Scrolls to top on every client-side route change.
 */

const ScrollController = () => {

    const { pathname } = useLocation ();

    useEffect ( () => {

        window.scrollTo ( 0, 0 );

    }, [ pathname ] );

    return null;

};

/** @exports ScrollController */

export default ScrollController;
